import { For } from "solid-js";
import { Portal } from "solid-js/web";

import xCircleSvg from "@uic/assets/icons/x-circle-bold.svg?raw";
import { UIAlert, UIButton, UIIcon } from "@uic/domain/generics";

import {
  NotificationVariant,
  toasts,
  dismiss,
} from "../core/notification-store";

/**
 * Global container that renders active toast notifications. Mounted once near
 * the app shell; reads the module-level notification store.
 * @returns {import('solid-js').JSX.Element} Toast stack
 */
export function ToastContainer() {
  return (
    <Portal>
      <div className="tw:d-toast tw:d-toast-end tw:d-toast-top tw:z-50">
        <For each={toasts()}>
          {(toast) => (
            <UIAlert
              variant={toast.variant}
              soft
              role={
                toast.variant === NotificationVariant.ERROR ? "alert" : "status"
              }
              className="tw:pr-2 tw:slorg-shadow-md"
            >
              <span>{toast.message}</span>
              <UIButton
                variant="ghost"
                size="xs"
                aria-label="Dismiss"
                onClick={() => dismiss(toast.id)}
              >
                <UIIcon svg={xCircleSvg} size="sm" />
              </UIButton>
            </UIAlert>
          )}
        </For>
      </div>
    </Portal>
  );
}
